import { render, staticRenderFns } from "./IncludedProductGroups.vue?vue&type=template&id=717b74fd&"
import script from "./IncludedProductGroups.vue?vue&type=script&lang=js&"
export * from "./IncludedProductGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports